/* eslint-disable */
import { BiShoppingBag, BiPencil } from "react-icons/bi";
import { BsCodeSlash, BsClipboardData, BsCameraVideoFill , BsHddRackFill } from "react-icons/bs";
import { AiOutlineMail, AiFillAudio } from "react-icons/ai";
import { FaInternetExplorer,  FaChalkboardTeacher, FaCameraRetro, FaPinterest, FaVideo, FaTabletAlt, FaRegNewspaper, FaLaptop, FaTv, FaShieldAlt, FaDesktop, FaPrint, FaNetworkWired  } from "react-icons/fa";
 

export const servicesData = [
    {
        id: 1,
        title: 'PC Building',
        icon: <FaTv/>
    },
    {
        id: 2,
        title: 'System and laptop Services',
        icon: <FaDesktop/> 
    },
    {
        id: 3,
        title: 'CCTV Sales & Services',
        icon: <BsCameraVideoFill />
    },

    {
        id: 6,
        title: 'PC and Laptops Sales',
        icon: <FaLaptop />
    },
    {
        id: 7,
        title: 'Antivirus sales',
        icon: <FaShieldAlt />
    },
   
    {
        id: 9,
        title: 'Printers Sales and Services',
        icon: <FaPrint />
    },
    
    {
        id: 11,
        title: 'Networking LAN WAN Technology',
        icon: <FaNetworkWired />
    },
   
]

// Uncomment your required service.
// Couldn't find the required services? Raise an issue on github at https://github.com/hhhrrrttt222111/developer-portfolio/issues/new
// You can also add on your own 😉.